const initialState = {
  all: {
    data: null,
    sorting: {
      page: 1,
      per_page: 21, // Init page size
      sort: 'name',
    },
    filters: {}, // Init state has no extra filters
    total: 0,
    get: {
      error: null,
      loading: false,
    },
  },
  determine: {
    data: null,
    get: {
      error: null,
      loading: false,
    },
  },
  bufferCalculate: {
    data: null,
    get: {
      error: null,
      loading: false,
    },
  },
  single: {
    data: null,
    get: {
      error: null,
      loading: false,
    },
  },
};

export default function systems(state = initialState, action) {
  const { type, payload } = action;

  switch (type) {
    // GET SYSTEMS
    case 'SYSTEMS_GET_ALL_REQUEST':
      return {
        ...state,
        all: {
          ...state.all,
          sorting: {
            ...state.all.sorting,
            ...payload.sorting,
          },
          filters: {
            ...state.all.filters,
            ...payload.filters,
          },
          get: {
            error: null,
            loading: true,
          },
        },
      };

    case 'SYSTEMS_GET_ALL_SUCCESS':
      return {
        ...state,
        all: {
          ...state.all,
          data: payload.data,
          total: payload.total,
          get: {
            error: null,
            loading: false,
          },
        },
      };

    case 'SYSTEMS_GET_ALL_FAILURE':
      return {
        ...state,
        all: {
          ...state.all,
          get: {
            error: payload,
            loading: false,
          },
        },
      };

    // DETERMINE SYSTEMS
    case 'SYSTEMS_DETERMINE_REQUEST':
      return {
        ...state,
        determine: {
          ...state.determine,
          data: null,
          get: {
            error: null,
            loading: true,
          },
        },
      };

    case 'SYSTEMS_DETERMINE_SUCCESS':
      return {
        ...state,
        determine: {
          ...state.determine,
          data: payload.data,
          get: {
            error: null,
            loading: false,
          },
        },
      };

    case 'SYSTEMS_DETERMINE_FAILURE':
      return {
        ...state,
        determine: {
          ...state.determine,
          data: null,
          get: {
            error: payload,
            loading: false,
          },
        },
      };

    // CALCULARE BUFFER
    case 'SYSTEMS_CALCULATE_BUFFER_REQUEST':
      return {
        ...state,
        bufferCalculate: {
          ...state.bufferCalculate,
          data: null,
          get: {
            error: null,
            loading: true,
          },
        },
      };

    case 'SYSTEMS_CALCULATE_BUFFER_SUCCESS':
      return {
        ...state,
        bufferCalculate: {
          ...state.bufferCalculate,
          data: payload.data,
          get: {
            error: null,
            loading: false,
          },
        },
      };

    case 'SYSTEMS_CALCULATE_BUFFER_FAILURE':
      return {
        ...state,
        bufferCalculate: {
          ...state.bufferCalculate,
          data: null,
          get: {
            error: payload,
            loading: false,
          },
        },
      };

    // GET SYSTEM
    case 'SYSTEM_GET_REQUEST':
      return {
        ...state,
        single: {
          ...state.single,
          get: {
            error: null,
            loading: true,
          },
        },
      };

    case 'SYSTEM_GET_SUCCESS':
      return {
        ...state,
        single: {
          ...state.single,
          data: payload.data,
          get: {
            error: null,
            loading: false,
          },
        },
      };

    case 'SYSTEM_GET_FAILURE':
      return {
        ...state,
        single: {
          ...state.single,
          get: {
            error: action.payload,
            loading: false,
          },
        },
      };

    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./js/reducers/systems.js